import * as z from 'zod';

export const FeatureSettingsSchema = z.object({
  enableExpenses: z.boolean(),
  enableProducts: z.boolean(),
  overdueReminderEnabled: z.boolean(),
  overdueReminderDays: z.number().int().min(1).max(90),
});
